import { createContext } from "react";
import { StateHandle } from "StateHandle";

export const ScriptSecretContext = createContext<StateHandle<string>>(["", null!]);
